import React, {Component, ReactElement} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import NatStepComponent, {DIspStepInfo, Step} from '../common/resident/NatStepComponent'
import NatResidentStaticContentsComponent from '../common/resident/NatResidentStaticContentsComponent'
import NatTokenRepo from '../token/repository/NatTokenRepo'
import {NatGetToken} from '../token/repository/NatGetToken'
import {AGREEMENT_TYPE, FIRST_LOGIN_REFERRER_ID, HAVE_OR_NOT, RESIDENT_USER_TYPE} from '../../../CodeMaster'
import {getQueryParameter, NatAsyncCallFunction} from '../../common/util/Natutil'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {CenterPlainLinkStyledButton, PrimaryStyledButton} from '../../../styledComponents/Button'
import {
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    WideMainContainer,
} from '../../../styledComponents/ContentsArea'
import {BreakPoint, Colors} from '../../../styledComponents/Constants'
import {generateMedia} from 'styled-media-query'
import {
    DisplayBlockDiv,
    DisplayCheckItemSelectionLabel,
    DisplayCheckItemSelectionName,
} from '../../../styledComponents/DisplayItem'
import {Box} from '@mui/material'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {Messages} from '../../../Messages'
import NatHasekoIdDescriptionDialogComponent from './resident/NatHasekoIdDescriptionDialogComponent'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {NatOwnershipTransfersRepo} from '../ownershipTransfers/repository/NatOwnershipTransfersRepo'
import {
    GuestLoginInfoSessionStorageKey,
    NatGuestLoginInfoSessionStorageHelper,
} from '../../common/authentication/NatGuestLoginInfoSessionStorageHelper'
import {Location} from 'react-router-dom'
import {HKConstants} from '../../../HKConstants'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'

interface FirstLoginLocationState {
    firstLoginReferrerId: string
    dIspStepInfo: DIspStepInfo
    policyAgreeType: string
    residentUserType: string
    referenceId: string
}

interface Props {
    tokenRepo: NatTokenRepo,
    ownershipTransfersRepo: NatOwnershipTransfersRepo
    roomToResidentRepo: NatRoomToResidentRepo
    location: Location<FirstLoginLocationState>
}

interface States {
    dIspStepInfo: DIspStepInfo
    firstLoginReferrerId: string
    referenceId: string
    mailAddress: Nullable<string>
    familyName: Nullable<string>
    firstName: Nullable<string>
    familyNameKana: Nullable<string>
    firstNameKana: Nullable<string>
    policy: string
    policyHaseko: string
    policyPolicy: string
    policySuteki: string
    policyBrc: string
    policyAgreeInfo: PolicyAgreeInfo[]
    nextButtonFlg: boolean
    flpExistFlag: string
    freeSettingItem: string
    isUserRegistrationApply: boolean
    dialogOpen: boolean
}

interface PolicyAgreeInfo {
    policyText: string,
    agree: boolean
}

class NatResidentFirstLoginPolicyAgreePage extends Component<Props & ResidentPagePropsSet, States> {
    firstLoginLocationState: FirstLoginLocationState | undefined
    queryToken: string
    authenticationKey: string | undefined

    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)
        this.state = {
            dIspStepInfo: {},
            firstLoginReferrerId: '',
            referenceId: '',
            mailAddress: null,
            familyName: null,
            firstName: null,
            familyNameKana: null,
            firstNameKana: null,
            policy: '',
            policyHaseko: '',
            policyPolicy: '',
            policySuteki: '',
            policyBrc: '',
            policyAgreeInfo: [],
            nextButtonFlg: true,
            flpExistFlag: HAVE_OR_NOT.NOT.value,
            dialogOpen: false,
            freeSettingItem: '',
            isUserRegistrationApply: false,
        };
        const locationState = this.props.location.state;
        if (locationState) {
            // @ts-ignore
            this.firstLoginLocationState = locationState.firstLoginLocationState
        }
        this.queryToken = getQueryParameter('token', this.props.location.search)

        this.backLoginButtonClick = this.backLoginButtonClick.bind(this)
        this.nextButtonClick = this.nextButtonClick.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
        this.handleDialogClick = this.handleDialogClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        // 遷移元画面ID　取得
        const firstLoginReferrerId = this.getFirstLoginReferrerId()
        let isUserRegistrationApply: boolean = false
        let freeSettingItem: string = ''

        // トークンが存在する場合
        if (this.queryToken) {
            await this.props.eventEmitter.showLoading()
            try {
                // トークンチェック
                const tokenInfo: Nullable<NatGetToken> =
                    await NatAsyncCallFunction(
                        this.props.tokenRepo.getToken.bind(
                            this.props.tokenRepo, this.queryToken), this.props.navigate)
                if (tokenInfo && tokenInfo.details === null) {
                    this.props.navigate('/resident/error', {state: {message: Messages.ERESR0003.toString()}})
                } else if (tokenInfo && tokenInfo.details) {
                    freeSettingItem = tokenInfo.details.freeSettingItem
                    isUserRegistrationApply = freeSettingItem === HKConstants.VRS.RES.USER_REGIST_URL ||
                        freeSettingItem === HKConstants.VRS.RES.USER_HASEKO_PASSWORD_CONFIRM_URL

                    if (isUserRegistrationApply) {
                        const condominiumData = await NatAsyncCallFunction(
                            this.props.roomToResidentRepo.getRoomToResidentByAuthenticationKey.bind(
                                this.props.roomToResidentRepo, tokenInfo.details.authenticationKey),
                            this.props.navigate
                        )
                        if (!(condominiumData && condominiumData.details)) {
                            this.props.navigate('/resident/error')
                        }
                    }
                    this.setState({flpExistFlag: tokenInfo.details.flpExistFlag})
                }
            } finally {
                this.props.eventEmitter.closeLoading()
            }
        }


        // アクセスキー取得（組合員資格変更届からの手続き）
        this.authenticationKey = getQueryParameter('authenticationKey', this.props.location.search)
        if (firstLoginReferrerId === FIRST_LOGIN_REFERRER_ID.OWNERSHIP_TRANSFER.value) {
            await this.props.eventEmitter.showLoading()
            try {
                const selectedCondominiumCd = NatGuestLoginInfoSessionStorageHelper.getStringItemOrNull(
                    GuestLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_CD,
                )
                // ログイン中の物件がある場合のみログイン中ユーザのアクセスキー取得
                if (selectedCondominiumCd) {
                    const getAccessKeyResult = await NatAsyncCallFunction(
                        this.props.ownershipTransfersRepo.getAccessKeyByLoginUser.bind(
                            this.props.ownershipTransfersRepo,
                            selectedCondominiumCd,
                        ), this.props.navigate)

                    if (getAccessKeyResult && getAccessKeyResult.details === null) {
                        this.props.navigate('/resident/error', {
                            state: {
                                message: Messages.EOSTG0010.toString(),
                                nonDisplayBackBtnFlag: true,
                            },
                        })
                    } else if (getAccessKeyResult && getAccessKeyResult.details) {
                        this.setState({referenceId: getAccessKeyResult.details.accessKey})
                    }

                    // 組合員資格変更届提出状況取得を取得
                    const getSubmitStatusResult = await NatAsyncCallFunction(
                        this.props.ownershipTransfersRepo.getOwnershipTransfersSubmitStatus.bind(
                            this.props.ownershipTransfersRepo, selectedCondominiumCd,
                        ), this.props.navigate)

                    if (!getSubmitStatusResult?.details) {
                        this.props.navigate('/resident/error', {
                            state: {
                                message: Messages.ESYCC0018.toString(),
                                nonDisplayBackBtnFlag: true,
                            },
                        })
                    } else {
                        // 組合員資格変更届-新組合員情報を取得
                        const getOwnershipTransferNewMember = await NatAsyncCallFunction(
                            this.props.ownershipTransfersRepo.getOwnershipTransferNewMember.bind(
                                this.props.ownershipTransfersRepo,
                                selectedCondominiumCd,
                                getSubmitStatusResult.details.applyId,
                            ), this.props.navigate)

                        if (!getOwnershipTransferNewMember?.details) {
                            this.props.navigate('/resident/error', {
                                state: {
                                    message: Messages.ESYCC0018.toString(),
                                    nonDisplayBackBtnFlag: true,
                                },
                            })
                        } else {
                            this.authenticationKey =
                                getOwnershipTransferNewMember.details.applyInfo.condominiumInfo.authenticationKey
                            this.setState({
                                mailAddress: getOwnershipTransferNewMember.details.newMemberInfo.mailAddress,
                                familyName: getOwnershipTransferNewMember.details.newMemberInfo.familyName,
                                firstName: getOwnershipTransferNewMember.details.newMemberInfo.firstName,
                                familyNameKana: getOwnershipTransferNewMember.details.newMemberInfo.familyNameKana,
                                firstNameKana: getOwnershipTransferNewMember.details.newMemberInfo.firstNameKana,
                            })
                        }
                    }
                }
            } finally {
                this.props.eventEmitter.closeLoading()
            }
        }

        // 規約情報取得
        let policy: string;
        let policyHaseko: string;
        let policyPolicy: string;
        let policySuteki: string;
        let policyBrc: string;
        let policyAgreeInfo: PolicyAgreeInfo[]
        policy = `/resources/contents/policy/terms_head.html`;
        policySuteki = `/resources/contents/policy/` + HKConstants.VMN.NTF.TERMS_FILENAME_SUTEKI;
        policyHaseko = `/resources/contents/policy/` + HKConstants.VMN.NTF.TERMS_FILENAME_HASEKO_PRIVACY;
        policyPolicy = `/resources/contents/policy/` + HKConstants.VMN.NTF.TERMS_FILENAME_PRIVACY_POLICY;
        policyBrc = `/resources/contents/policy/` + HKConstants.VMN.NTF.TERMS_FILENAME_BRANCIELA;
        policyAgreeInfo = [
            {policyText: '「素敵ネット利用規約」に同意する', agree: false},
            {policyText: '「長谷工ID利用規約」に同意する', agree: false},
            {policyText: '「個人情報保護方針」に同意する', agree: false},
            {policyText: '「ブランシエラクラブ利用規約」に同意する', agree: false}
        ];

        // STEP
        let step: DIspStepInfo = {}
        if (this.queryToken) {
            if (isUserRegistrationApply) {
                // ユーザ登録申請の場合
                step = {
                    policy: true,
                    userRegister: freeSettingItem === HKConstants.VRS.RES.USER_REGIST_URL,
                    hasekoIdPasswordConfirm: freeSettingItem === HKConstants.VRS.RES.USER_HASEKO_PASSWORD_CONFIRM_URL,
                    userConfirm: true,
                    complete: true,
                }
            } else {
                // サブユーザの場合
                step = {
                    policy: true,
                    hasekoIdConfirm: true,
                    subUserRegister: true,
                    subUserConfirm: true,
                    complete: true,
                }
            }
        } else {
            // メインユーザの場合
            // 組合員資格変更届による素敵ネット登録の場合
            if (firstLoginReferrerId === FIRST_LOGIN_REFERRER_ID.OWNERSHIP_TRANSFER.value) {
                step = {
                    policy: true,
                    mailAddressRegister: true,
                    mailReceive: true,
                };
            } else {
                step = {
                    policy: true,
                    authenticationKey: true,
                    hasekoIdConfirm: true,
                    mailAddressRegister: true,
                    mailReceive: true,
                };
            }
        }

        this.setState({
            dIspStepInfo: step,
            policy: policy,
            policyHaseko: policyHaseko,
            policyPolicy: policyPolicy,
            policySuteki: policySuteki,
            policyBrc: policyBrc,
            policyAgreeInfo: policyAgreeInfo,
            firstLoginReferrerId: firstLoginReferrerId,
            dialogOpen: firstLoginReferrerId !== FIRST_LOGIN_REFERRER_ID.HASEKO_ID_DESCRIPTION.value,
            freeSettingItem: freeSettingItem,
            isUserRegistrationApply: isUserRegistrationApply,
        })
    }

    getFirstLoginReferrerId(): string {
        let firstLoginReferrerId: string = ''
        if (this.firstLoginLocationState !== undefined) {
            firstLoginReferrerId = this.firstLoginLocationState.firstLoginReferrerId
        } else {
            firstLoginReferrerId = getQueryParameter('referrerId', this.props.location.search)
        }
        return firstLoginReferrerId
    }

    // 規約同意
    renderPolicyAgree(): ReactElement {
        return (
            <>
                {this.state.policyAgreeInfo.map((policy, index) => {
                    return (
                        <DisplayCheckItemSelectionLabel key={index}>
                            <DisplayCheckItemSelectionName>
                                <input type="checkbox"
                                       defaultChecked={policy.agree}
                                       onChange={this.handleInputChange}
                                       id={String(index)}
                                />
                                <span>{policy.policyText}</span>
                            </DisplayCheckItemSelectionName>
                        </DisplayCheckItemSelectionLabel>
                    )
                })}
            </>
        )
    }

    // 入力
    handleInputChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const changedPolicyId = Number(event.target.id)
        const policyAgreeInfo: PolicyAgreeInfo[] = this.state.policyAgreeInfo
        let nextButtonFlg: boolean

        policyAgreeInfo[changedPolicyId].agree = (event.target.checked)

        // 活性/非活性　制御
        nextButtonFlg = policyAgreeInfo.some((policy) => !policy.agree)

        this.setState({
            nextButtonFlg: nextButtonFlg,
            policyAgreeInfo: policyAgreeInfo,
        })
    }

    // 次へ
    nextButtonClick(): void {
        let nextUrl: string = ''
        let policyAgreeType: string = ''
        let residentUserType: string = ''

        if (this.queryToken) {
            if (this.state.isUserRegistrationApply) {
                // ユーザ登録申請の場合
                residentUserType = RESIDENT_USER_TYPE.MAIN.value
                nextUrl = `/${this.state.freeSettingItem}?token=${this.queryToken}`
                policyAgreeType = AGREEMENT_TYPE.SUTEKI_AND_HASOKO.value
            } else {
                // サブユーザの場合
                residentUserType = RESIDENT_USER_TYPE.SUB.value;
                nextUrl = `/resident/firstLoginHasekoIdConfirm?token=${this.queryToken}`;
                policyAgreeType = AGREEMENT_TYPE.SUTEKI_AND_HASOKO.value;
            }
        } else {
            // メインユーザの場合
            residentUserType = RESIDENT_USER_TYPE.MAIN.value;
            nextUrl = this.state.firstLoginReferrerId === FIRST_LOGIN_REFERRER_ID.OWNERSHIP_TRANSFER.value
                ? `/resident/firstLoginMailAddressRegister`
                : `/resident/firstLoginAuthenticationKeyInput?token=${this.queryToken}`;
            policyAgreeType = AGREEMENT_TYPE.SUTEKI_AND_HASOKO.value;
        }

        this.props.navigate(
            nextUrl,
            {
                state: {
                    firstLoginLocationState: {
                        firstLoginReferrerId: FIRST_LOGIN_REFERRER_ID.POLICY_AGREE.value,
                        policyAgreeType: policyAgreeType,
                        residentUserType: residentUserType,
                        dIspStepInfo: this.state.dIspStepInfo,
                        authenticationKey: this.authenticationKey,
                        referenceId: this.state.referenceId,
                        mailAddress: this.state.mailAddress,
                        familyName: this.state.familyName,
                        firstName: this.state.firstName,
                        familyNameKana: this.state.familyNameKana,
                        firstNameKana: this.state.firstNameKana,
                    },
                },
            },
        )
    }

    // ログインページへ
    backLoginButtonClick(): void {
        this.props.navigate(this.state.firstLoginReferrerId === FIRST_LOGIN_REFERRER_ID.OWNERSHIP_TRANSFER.value
                ? `/guest/mypage?accessKey=${this.state.referenceId}`
                : `/resident/login`
        )
    }

    handleDialogClick(): void {
        this.setState({dialogOpen: false})
    }

    render(): Nullable<ReactElement> {
        if (this.state.policy === '') {
            return null
        } else {
            return (
                <>
                    <NatHasekoIdDescriptionDialogComponent
                        open={this.state.dialogOpen}
                        handleClick={this.handleDialogClick}
                    />
                    <NatStepComponent dIspStepInfo={this.state.dIspStepInfo} nowStep={Step.POLICY}/>
                    <ContentsSubTitleWrapper>
                        <ContentsSubTitleInner>
                            「素敵ネット」利用規約
                        </ContentsSubTitleInner>
                    </ContentsSubTitleWrapper>
                    <WideMainContainer>
                        <BlockSpacer height={'15px'}/>
                        <PolicyBlock>
                            <NatResidentStaticContentsComponent contents={this.state.policy}/>
                            <NatResidentStaticContentsComponent contents={this.state.policySuteki}/>
                            <NatResidentStaticContentsComponent contents={this.state.policyHaseko}/>
                            <NatResidentStaticContentsComponent contents={this.state.policyPolicy}/>
                            <NatResidentStaticContentsComponent contents={this.state.policyBrc}/>
                        </PolicyBlock>
                        <DisplayBlockDiv>
                            {this.renderPolicyAgree()}
                        </DisplayBlockDiv>
                        <BlockSpacer height={'5px'}/>
                    </WideMainContainer>
                    <BlockSpacer height={'30px'}/>
                    <PrimaryStyledButton
                        onClick={this.nextButtonClick}
                        disabled={this.state.nextButtonFlg}>
                        次へ進む
                    </PrimaryStyledButton>
                    <Box height={'30px'}/>
                    <CenterPlainLinkStyledButton onClick={this.backLoginButtonClick}>
                        {this.state.firstLoginReferrerId === FIRST_LOGIN_REFERRER_ID.OWNERSHIP_TRANSFER.value
                            ? 'トップページへ戻る'
                            : 'ログイン画面へ戻る'
                        }
                    </CenterPlainLinkStyledButton>
                    <BlockSpacer height={'30px'}/>
                </>
            )
        }
    }
}

export default createResidentPage(NatResidentFirstLoginPolicyAgreePage)


const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

// 利用規約
const PolicyBlock: StyledDiv = styled.div`
  height: 400px;
  margin: 0 0 15px;
  padding: 32px;
  border: 1px solid ${Colors.AccentLight};
  overflow-y: scroll;

    ${breakPoint.lessThan('sp')`
     height: auto;
     padding: 0;
     border: initial;
     overflow-y: initial;
  `}
`;
